/**
 * Toggles variant-selects[data-ground-exchange-active] when the watched option
 * is not one of the exempt values (CSS shows .product__ground-exchange-note).
 */
(function () {
  'use strict';

  function optionInputsByName(vs, optName) {
    var fullName = 'options[' + optName + ']';
    var all = vs.querySelectorAll('input');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].name === fullName) out.push(all[i]);
    }
    return out;
  }

  function parseExempt(vs) {
    var raw = vs.getAttribute('data-ground-exchange-exempt') || '';
    return raw
      .split(',')
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function getSelectedValue(vs, optName) {
    var inputs = optionInputsByName(vs, optName);
    var val = '';
    var i;
    for (i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.type === 'radio' || inp.type === 'checkbox') {
        if (inp.checked) {
          val = inp.value || '';
          break;
        }
      }
    }
    if (!val) {
      for (i = 0; i < inputs.length; i++) {
        if (inputs[i].type === 'hidden') {
          val = inputs[i].value || '';
          break;
        }
      }
    }
    return (val || '').trim();
  }

  function isExempt(valLower, exemptList) {
    for (var i = 0; i < exemptList.length; i++) {
      if (exemptList[i] === valLower) return true;
    }
    return false;
  }

  function syncVariantSelects(vs) {
    var optName = vs.getAttribute('data-ground-exchange-option');
    if (!optName) return;
    var exempt = parseExempt(vs);
    var val = getSelectedValue(vs, optName).toLowerCase();
    var show = val !== '' && !isExempt(val, exempt);
    if (show) {
      vs.setAttribute('data-ground-exchange-active', '');
    } else {
      vs.removeAttribute('data-ground-exchange-active');
    }
  }

  function syncAll() {
    var nodes = document.querySelectorAll('variant-selects[data-ground-exchange-option]');
    for (var i = 0; i < nodes.length; i++) {
      syncVariantSelects(nodes[i]);
    }
    syncComingSoon();
    syncZeroPriceAtc();
  }

  function syncComingSoon() {
    var forms = document.querySelectorAll('form[data-coming-soon="true"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var label = form.getAttribute('data-coming-soon-label') || 'Coming soon';
      var root = form.closest('product-form') || form.parentElement || form;
      var button = root.querySelector('[data-add-to-cart]');
      var buttonText = root.querySelector('[data-add-to-cart-text]');
      var buyNow = root.querySelector('[data-buy-it-now]');

      if (button) {
        button.setAttribute('type', 'button');
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        button.removeAttribute('name');
      }

      if (buttonText) {
        buttonText.textContent = label;
      }

      if (buyNow) {
        buyNow.classList.add('hidden');
      }
    }
  }

  function syncZeroPriceAtc() {
    var forms = document.querySelectorAll('form[data-product-form]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var root = form.closest('product-form') || form.parentElement || form;
      var textEl = root.querySelector('[data-add-to-cart-text]');
      var priceEl = root.querySelector('[data-product-price]');
      var defaultAddToCart = (window.theme && window.theme.strings && window.theme.strings.add_to_cart) || 'Add to Cart';
      var freeLabel = (window.theme && window.theme.strings && window.theme.strings.free) || 'Free';
      var callForPriceFlagInput = form.querySelector('[data-call-for-price-flag]');
      var callForPriceLabelInput = form.querySelector('[data-call-for-price-label]');
      var zeroPriceFlagInput = form.querySelector('[data-zero-price-flag]');
      var callForPriceFlag = callForPriceFlagInput && callForPriceFlagInput.value === 'true';
      var callForPriceLabel = (callForPriceLabelInput && callForPriceLabelInput.value) || 'Call for price';
      var isZeroPrice = zeroPriceFlagInput && zeroPriceFlagInput.value === 'true';
      var forceLabel = callForPriceFlag ? callForPriceLabel : defaultAddToCart;

      if ((callForPriceFlag || isZeroPrice) && textEl) {
        textEl.removeAttribute('data-atc-button');
        textEl.removeAttribute('data-price-wrapper');
        textEl.textContent = forceLabel;
        // Guard against any async theme update appending " • FREE".
        var current = (textEl.textContent || '').trim();
        var freeSuffix = new RegExp('\\s*[•\\-]\\s*' + freeLabel + '\\s*$', 'i');
        textEl.textContent = current.replace(freeSuffix, '').trim();
      }
      if ((callForPriceFlag || isZeroPrice) && priceEl && priceEl.parentNode) {
        priceEl.parentNode.removeChild(priceEl);
      }
    }
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var vs = t.closest('variant-selects[data-ground-exchange-option]');
      if (vs) syncVariantSelects(vs);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, syncAll);
  }
})();
